




import { defineComponent, onMounted } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Attivazioni',
  layout: 'attivazioni',
  setup() {
    onMounted(() => {
      window.location.replace('/landing'); 
    });
  }
});
